exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 576px) {\n.reason-modal-size .modal-dialog .modal-content {\n    min-height: 285px !important;\n}\n}\n", ""]);

// exports
